import { JSX } from 'react';
import { CtaContentCard } from '@ahc-digital/component-library';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';
import { C20CTAContentCardProps } from './C20CTAContentCard.types';
import { CreateCTAContentCardModel } from './C20CTAContentCard.service';

const Default = (props?: C20CTAContentCardProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  return (
    <CtaContentCard
      className={translationClasses(props?.params)}
      id={props?.params?.AnchorLinkTargetName}
      data-component={marketingRenderingName}
      {...CreateCTAContentCardModel(props)}
    />
  );
};

export default checkDatasourceForRendering<C20CTAContentCardProps>(Default);
